import { render, staticRenderFns } from "./CampaignSettings.vue?vue&type=template&id=42f4c64b&scoped=true"
import script from "./CampaignSettings.vue?vue&type=script&lang=js"
export * from "./CampaignSettings.vue?vue&type=script&lang=js"
import style0 from "./CampaignSettings.vue?vue&type=style&index=0&id=42f4c64b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f4c64b",
  null
  
)

export default component.exports